import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  t
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-region-indicator/jb-region-indicator.scss?inline
var jb_region_indicator_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

ul {
  align-items: center;
  cursor: pointer;
  display: var(--display, flex);
  font-size: 0;
  position: relative;
  z-index: 10;
}
ul::after {
  display: none;
  right: var(--after-right, 100%);
  top: 35px;
}
@media (min-width: 1281px) {
  ul::after {
    display: block;
  }
}
ul:hover::after {
  right: 30px;
}
@supports (-webkit-appearance: none) {
  ul:hover::after {
    right: 13%;
  }
}
@media all and (-ms-high-contrast: none) {
  ul:hover::after {
    right: 13%;
  }
}

::slotted(jb-region-indicator-item:not(:last-of-type)) {
  --dot-display: block;
  --padding-right: 20px;
}`;

// src/components/jb-region-indicator/jb-region-indicator.ts
var JbRegionIndicator = class extends r2 {
  firstUpdated() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.dispatchEvent(new CustomEvent("region-indicator:clicked", { bubbles: true, composed: true }));
    });
    this.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.code === "Space") {
        e.preventDefault();
        e.target.click();
      }
    });
    this.requestUpdate();
  }
  render() {
    return ke`<ul tabindex="0">
      <slot></slot>
    </ul>`;
  }
};
JbRegionIndicator.styles = r(jb_region_indicator_default);
JbRegionIndicator = __decorateClass([
  t("jb-region-indicator")
], JbRegionIndicator);

export {
  JbRegionIndicator
};
